import { useTranslation } from 'react-i18next'

import { ComboBox, RadioGroup } from '@reveni-io/reveni-ui'

import { getReasonMenuItems, getReasonTypeMenuItems } from '@/common/helpers/helpers'

import { filterLevelOptions, filterLevels } from './constants'

const ReturnReasonFilter = ({
  returnReasons = [],
  value = [],
  onChange,
  filterLevel = filterLevels.reasonType,
  onChangeFilterLevel,
}) => {
  const { t, i18n } = useTranslation()

  const isReasonType = filterLevel === filterLevels.reasonType
  const menuItems = isReasonType
    ? getReasonTypeMenuItems(i18n.language)
    : getReasonMenuItems(returnReasons, i18n.language)

  return (
    <div>
      <RadioGroup
        label={t('Nivel de filtrado')}
        name="return-reason-filter-level"
        options={filterLevelOptions(t)}
        value={filterLevel}
        onChange={e => onChangeFilterLevel(e.target.value)}
      />
      <ComboBox
        menuItems={menuItems}
        value={value || []}
        multiple
        fullWidth
        label={isReasonType ? t('Tipo de motivo de devolución') : t('Motivo de devolución')}
        handleChange={e => onChange(e.target.value)}
      />
    </div>
  )
}

export default ReturnReasonFilter
